import type {
  BarChartDataType,
  GasAnalysisDateRangePriodParams,
  GetElecAnalysisMarketMonitoringMarketDifferenceComparisonTableResponse,
  GetGasAnalysisMarketMonitoringBandsChartParams,
  GetGasAnalysisMarketMonitoringBandsChartResponse,
  GetGasAnalysisMarketMonitoringFutureProdChartParams,
  GetGasAnalysisMarketMonitoringFutureProdChartResponse,
  GetGasAnalysisMarketMonitoringFutureProdDailyResponse,
  GetGasAnalysisMarketMonitoringIndicatorsParams,
  GetGasAnalysisMarketMonitoringIndicatorsResponse,
  GetGasAnalysisMarketMonitoringMarketDifferenceChartParams,
  GetGasAnalysisMarketMonitoringMarketDifferenceChartResponse,
  GetGasAnalysisMarketMonitoringMarketYearlyDifferenceChartParams,
  GetGasAnalysisMarketMonitoringMarketYearlyDifferenceChartResponse,
  GetGasAnalysisMarketMonitoringMarketYearlyDifferenceIndicatorsResponse,
  GetGasAnalysisMarketMonitoringMarketYearlyDifferenceTableResponse,
  GetGasAnalysisMarketMonitoringSpotChartParams,
  GetGasAnalysisMarketMonitoringSpotChartResponse,
  GetGasAnalysisMarketMonitoringTreeChartParams,
  GetGasAnalysisMarketMonitoringTreeChartResponse,
  GetGasAnalysisMarketMonitoringMarketDifferenceDailyResponse,
  GetGasAnalysisMarketMonitoringFutureProdComparisonTableResponse,
} from "$/lib/types/api/market-monitoring/gas-analysis.types";
import { restApiClient } from "../restApiClient";

export const getGasAnalysisTreeChart = async (
  params: GetGasAnalysisMarketMonitoringTreeChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/tree-chart")
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringTreeChartResponse>();
};

export const getGasAnalysisFutureProductsChart = async (
  params: GetGasAnalysisMarketMonitoringFutureProdChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/future-products-chart")
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringFutureProdChartResponse>();
};

export const getGasAnalysisFutureProdDaily = async (params: {
  date: string;
}) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/future-products-daily")
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringFutureProdDailyResponse>();
};

export const getGasAnalysisFutureProdComparisonTable = async (
  params: GasAnalysisDateRangePriodParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/future-products-comparison-table")
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringFutureProdComparisonTableResponse>();
};

export const getGasBandsChart = async (
  params: GetGasAnalysisMarketMonitoringBandsChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/bands-chart")
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringBandsChartResponse>();
};

export const getGasAnalysisIndicators = async (
  params: GetGasAnalysisMarketMonitoringIndicatorsParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/indicators")
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringIndicatorsResponse>();
};

export const getGasMarketDifferenceChart = async (
  params: GetGasAnalysisMarketMonitoringMarketDifferenceChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/market-difference-chart")
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringMarketDifferenceChartResponse>();
};

export const getGasMarketDifferenceDaily = async (params: { date: string }) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/market-difference-daily")
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringMarketDifferenceDailyResponse>();
};

export const getGasMarketDifferenceComparisonTable = async (
  params: GasAnalysisDateRangePriodParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/market-difference-comparison-table")
    .query({ ...params })
    .get<GetElecAnalysisMarketMonitoringMarketDifferenceComparisonTableResponse>();
};

export const getGasMarketYearlyDifferenceChart = async (
  params: GetGasAnalysisMarketMonitoringMarketYearlyDifferenceChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/market-yearly-difference-chart")
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringMarketYearlyDifferenceChartResponse>();
};

export const getGasMarketYearlyDifferenceDailyIndicators = async (params: {
  date: string;
}) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/market-yearly-difference-indicators")
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringMarketYearlyDifferenceIndicatorsResponse>();
};

export const getGasMarketYearlyDifferenceComparisonTable = async (
  params: GasAnalysisDateRangePriodParams,
) => {
  return restApiClient
    .url(
      "/market-monitoring/gas-analysis/market-yearly-difference-comparison-table",
    )
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringMarketYearlyDifferenceTableResponse>();
};

export const getGasAnalysisSpotChart = async (
  params: GetGasAnalysisMarketMonitoringSpotChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/spot-price-chart")
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringSpotChartResponse>();
};

export const getGasRSIChart = async (
  params: GetGasAnalysisMarketMonitoringBandsChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/rsi-chart")
    .query({ ...params })
    .get<GetGasAnalysisMarketMonitoringBandsChartResponse>();
};

// Bar charts

export const getPEG_DAAvgYearly = async () => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/peg-da-avg-yearly")
    .get<BarChartDataType[]>();
};

export const getGasAvgYearly = async () => {
  return restApiClient
    .url("/market-monitoring/gas-analysis/gas-avg-yearly")
    .get<BarChartDataType[]>();
};
